// extracted by mini-css-extract-plugin
export default {"nameButton":"YogTS"};